import { textDecoration } from "@chakra-ui/react";

export default {
    baseStyle: {
        // PromoCode accordion component
        accordionItem: {
            borderTop: 0,
            borderBottom: '1px solid',
            borderBottomColor: 'webTheme.strokeTertiary'
        },
        accordionButton: {
            pt: 0,
            pb: 3,
            px: 0,
            _hover: {bg: 'transparent'}
        },
        accordionButtonText: {
            color: 'webTypo.textPrimary',
            textStyle: 'bodySmRegular',
            flex: '1',
            textAlign: 'left'
        },
        accordionArrow: {
            transition: 'transform 0.2s ease-in-out',
            transform: 'rotate(0deg)'
        },
        accordionArrowExpanded: {
            transform: 'rotate(180deg)'
        },
        accordionPanel: {
            px: 0,
            pb: 3
        },
        appliedCouponsStack: {
            spacing: 3,
            mb: 3
        },
        couponCard: {
            bg: 'webTheme.fieldDefault',
            px: 4,
            py: 2,
            border: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
        },
        couponCardFlex: {
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        couponCode: {
            color: 'webTypo.textPrimary',
            textStyle: 'bodyXsBold',
        },
        couponPromoName: {
            color: 'webTypo.textPrimary',
            textStyle: 'bodyXsRegular',
        },
        removeButton: {
            variant: 'unstyled',
            display: 'block',
            textStyle: 'bodyXsLink',
            textDecoration: 'underline'
        },
        addAnotherButton: {
            variant: 'unstyled',
            textStyle: 'labelXs',
            display: 'flex',
            alignItems: 'center',
            p: 0,
            height: 'auto'
        },

        // PromoCodeFields component
        fieldsContainer: {
            gap: 3,
            alignItems: 'flex-start'
        },
        fieldWrapper: {
            flex: '1'
        },
        applyButton: {
            variant: 'webSecondaryOutlineSmall',
            minWidth: '124px',
            minHeight: '48px'
        }
    }
}
